import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import Amplify from 'aws-amplify';
import axios from 'axios';
import './index.css';
import ConnectedApp from './App';
import register, { unregister } from './registerServiceWorker';


// block ReactDOM.render until ajax returns the config values
// otherwise amplify withAuthenticator can't properly initialize
const configureAmplify = async () => {
  const config = await axios.get(`${window.location.protocol}//${window.location.host}/config/config.json`);

  await Amplify.configure({
    Auth: {
      region: config.data.region,
      userPoolWebClientId: config.data.graphQL.aws_user_pools_web_client_id,
      userPoolId: config.data.UserPoolId,
    },
    API: {
      graphql_endpoint: config.data.graphQL.graphqlEndpointACIInfo,
      graphql_headers: async () => ({
        Authorization: localStorage.getItem('jwtToken')
      })
    }
  });

  ReactDOM.render(<ConnectedApp />, document.getElementById('root'));
};

configureAmplify();
unregister();


// WEBPACK FOOTER //
// ./src/index.js